import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import { Popover } from "antd"
import { validate } from "../../../utils/functions"
import { loadTexts, sanitize } from "../../../utils/i18n"

export function PopoverBenchmark(props) {
  const intl = loadTexts("reports_general_view")
  const intlBenchmark =
    intl.reportAmbassador.engagementMeasurement.widgetResume.benchmark
  const renderContent = () => {
    return (
      <div style={{ width: "256px" }}>
        {sanitize(intlBenchmark.tooltip.text)}
        <span style={{ fontSize: "10px" }}>
          {props.isGlobalBenchmark
            ? sanitize(intlBenchmark.tooltip.noteGlobalBenchmark)
            : sanitize(intlBenchmark.tooltip.noteIndustrieBenchmark)}
        </span>
      </div>
    )
  }

  return (
    <Popover
      overlayClassName="PopoverBenchmark"
      content={renderContent()}
      title="Benchmark Mandü">
      {validate.exist(props.container) ? (
        props.container
      ) : (
        <span className="PopoverBenchmark-text">{intlBenchmark.label}</span>
      )}
    </Popover>
  )
}

PopoverBenchmark.propTypes = {
  isGlobalBenchmark: PropTypes.bool,
  container: PropTypes.object,
}

export default PopoverBenchmark
